import React, { useState, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { createData } from "../../utility/managerApi";

function ImportProduct() {
  const [isImport, setIsImport] = useState(false);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState(new FormData());

  const mutation = useMutation({
    mutationFn: (formData) => createData("products/import", formData),
    onSuccess: () => {
      setIsImport(false);
    },
  });

  const handleImport = () => {
    setIsImport(true);
  };

  const handleChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  useEffect(() => {
    if (file) {
      const newFormData = new FormData();
      newFormData.append("csv_file", file);
      setFormData(newFormData);
    }
  }, [file]);

  const handleUpload = () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    mutation.mutate(formData);
  };

  return (
    <>
      {isImport ? (
        <div className="flex gap-2 items-center">
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleChange}
            className="w-60"
          />
          <button
            onClick={handleUpload}
            className="p-4 rounded-lg text-white bg-green-500"
          >
            Upload copy
          </button>
        </div>
      ) : (
        <button
          onClick={handleImport}
          className="p-4 rounded-lg text-white bg-green-500"
        >
          Import Product
        </button>
      )}
    </>
  );
}

export default ImportProduct;
